import { create } from 'zustand';
import { nanoid } from 'nanoid';

type ToastConfig = {
  id: string;
  text: string;
  image?: string;
  action?: string;
  isLight?: boolean;
  duration?: number;
  onActionClick?: () => void;
};

interface ToastState {
  queue: ToastConfig[];
  isOpen: boolean;
  activeToast: ToastConfig | null;
  openToast: (config: Omit<ToastConfig, 'id'>) => void;
  showNext: () => void;
  closeToast: () => void;
  onAnimationComplete: () => void;
}

export const useToastStore = create<ToastState>((set, get) => ({
  queue: [],
  isOpen: false,
  activeToast: null,
  openToast: config => {
    const id = nanoid();
    const newToast = { ...config, id };

    set({ queue: [...get().queue, newToast] });

    if (get().activeToast && get().isOpen) {
      set({ isOpen: false });
    } else {
      get().showNext();
    }
  },
  showNext: () => {
    const { queue } = get();

    if (queue.length > 0) {
      const next = queue[0];

      set({ activeToast: next, queue: queue.slice(1), isOpen: true });
    } else {
      set({ activeToast: null, isOpen: false });
    }
  },

  closeToast: () => set({ isOpen: false }),

  onAnimationComplete: () => {
    set({ activeToast: null });
    get().showNext();
  },
}));

export const useToast = () => ({
  openToast: useToastStore(state => state.openToast),
});
